// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"f025add6","455":"1784568e","977":"70df07fa"}[chunkId] + ".chunk.js";
};